import React, { PureComponent } from 'react';
import { createSelector } from 'reselect';
import { utcFormat, utcDay } from 'd3'
import Selector from './Selector';
import DatePicker from './DatePicker'
import { periods } from './periods';
import { translate } from './translate';


//filter out buttons not in use?
const availableTimePeriods = createSelector(
  props => props.availableTimeRange,
  ([firstDate, latestDate]) => {

    // let d = new Date();
    let d = new Date(latestDate)
    // console.log('AA latestDate', d)

    let Q1S = new Date(d.getFullYear(), 0, 1);
    let Q1E = new Date(Q1S.getFullYear(), 2, 31);
    let Q2S = new Date(d.getFullYear(), 3, 1);
    let Q2E = new Date(Q2S.getFullYear(), 5, 30);
    let Q3S = new Date(d.getFullYear(), 6, 1);
    let Q3E = new Date(Q3S.getFullYear(), 8, 30);
    let Q4S = new Date(d.getFullYear(), 9, 1);
    let Q4E = new Date(Q4S.getFullYear(), 11, 31);
    let PCYS = new Date(d.getFullYear() - 1, 0, 1);
    let PCYE = new Date(PCYS.getFullYear(), 11, 31);

    // const startDtBefQ1 = firstDate <= Q1S
    // const startDtBefQ2 = firstDate <= Q1E
    // const startDtBefQ3 = firstDate <= Q2E
    // const startDtBefQ4 = firstDate <= Q3E
    const startDtinPCY = firstDate <= PCYE

    const startDtInQ1 = firstDate >= Q1S && firstDate < Q1E
    const startDtInQ2 = firstDate >= Q2S && firstDate < Q2E
    const startDtInQ3 = firstDate >= Q3S && firstDate < Q3E
    const startDtInQ4 = firstDate >= Q4S && firstDate < Q4E


    const latestDtInQ1 = latestDate >= Q1S && latestDate < Q1E
    const latestDtInQ2 = latestDate >= Q2S && latestDate < Q2E
    const latestDtInQ3 = latestDate >= Q3S && latestDate < Q3E
    const latestDtInQ4 = latestDate >= Q4S && latestDate < Q4E

    let showQ1 = false;
    let showQ2 = false;
    let showQ3 = false;
    let showQ4 = false;
    let showPCY = false;

    if (startDtinPCY && latestDtInQ1) {
      showPCY = true;
    }
    if (startDtinPCY && latestDtInQ2) {
      showPCY = true;
      showQ1 = true;
    }
    if (startDtinPCY && latestDtInQ3) {
      showPCY = true;
      showQ1 = true;
      showQ2 = true;
    }
    if (startDtinPCY && latestDtInQ4) {
      showPCY = true;
      showQ1 = true;
      showQ2 = true;
      showQ3 = true;
    }

    if (latestDtInQ4 && startDtInQ3) {
      showQ3 = true;
    }
    if (latestDtInQ3 && startDtInQ1) {
      showQ1 = true;
      showQ2 = true;
    }
    if (latestDtInQ4 && startDtInQ2) {
      showQ2 = true;
      showQ3 = true;
    }
    if (latestDtInQ3 && startDtInQ2) {
      showQ2 = true;
    }

    if (latestDtInQ2 && startDtInQ1) {
      showQ1 = true;
    }




    if (showPCY && showQ1 && showQ2 && showQ3) {
      console.log('AA  P,1,2,3')
      return [
        '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'PCY', 'Q1', 'Q2', 'Q3', 'INC', 'CUSTOM'
      ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
    } else
      if (showPCY && showQ1 && showQ2) {
        console.log('AA  P,1,2,3')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'PCY', 'Q1', 'Q2', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
      } else if (showQ2 && showQ3) {
        console.log('AA  Q2 & Q3 ')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'Q2', 'Q3', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)

      } else if (showQ2) {
        console.log('AA  Q2')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'Q2', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
      }
      else if (showQ3) {
        console.log('AA  Q3')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'Q3', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)

      }
      else if (showQ1 && showQ2 && showQ3) {
        console.log('AA  Q1, Q2, Q3')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'Q1', 'Q2', 'Q3', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
      } else if (showQ1 && showQ2) {
        console.log('AA  Q1,Q2 ')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'Q1', 'Q2', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)

      } else if (showQ1) {
        console.log('AA  Q1')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'PCY', 'Q1', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
      }
      else if (showPCY) {
        console.log('AA  PCY')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'PCY', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
      }
      else if (showPCY && showQ1) {
        console.log('AA  PCY Q1')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'PCY', 'Q1', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
      }
      else {

        console.log('AA default ')
        return [
          '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y', 'YTD', 'INC', 'CUSTOM'
        ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
      }
  }


)

const periodIdWithLabel = createSelector(
  props => props.i18n,
  props => props.lang,
  (props, state) => state.customRange,
  (props, state) => state.customEditState,
  (i18n, lang, customRange, customEditState) => id => {
    if (id === 'CUSTOM') {
      const [date0, date1] = customRange
      const formatDate = utcFormat('%x')
      return {
        id,
        label: date0 === null && date1 === null ? translate('CUSTOM', i18n, lang) : formatDate(date0) + ' - ' + (date1 === null ? '' : formatDate(date1)),
        customClassName: `PeriodSelector-custom-range-option ${customEditState !== OFF ? 'in-edit' : ''}`
      }
    }

    else {
      return { id, label: translate(id, i18n, lang) }
    }
  }
)

const [OFF, DATE0, DATE1] = ['off', 'date0', 'date1']

class PeriodSelector extends PureComponent {
  constructor() {
    super()
    this.state = {
      customRange: [null, null],//[new Date(2017, 2, 1), new Date(2017, 5, 1)],
      customEditState: OFF // or DATE0, DATE1
    }
    this.handleSubmitCustomDate0 = this.handleSubmitCustomDate0.bind(this)
    this.handleSubmitCustomDate1 = this.handleSubmitCustomDate1.bind(this)
    this.handleSelected = this.handleSelected.bind(this)
  }
  handleSelected(selectedPeriod) {
    const { selected, onSelect } = this.props

    if (selectedPeriod === 'CUSTOM') {
      const { customRange } = this.state
      const [date0, date1] = customRange
      if (selected === selectedPeriod || (date0 === null && date1 === null)) {
        this.setState({ customEditState: DATE0, customRevertRange: customRange })
      }
      else {
        onSelect(selectedPeriod, customRange)
      }
    }
    else {
      this.setState({ customEditState: OFF })
      onSelect(selectedPeriod)
    }
  }
  gotoEditState(targetState) {
    return () => this.setState({ customEditState: targetState })
  }

  handleSubmitCustomDate0(date0) {
    const { customRange } = this.state
    const newRange = [date0, customRange[1]]
    this.setState({
      customRange: newRange,
      customEditState: DATE1
    })
  }
  handleSubmitCustomDate1(date1) {
    const { onSelect } = this.props
    const { customRange } = this.state
    const newRange = [
      new Date(Math.min(utcDay.offset(date1, -7), customRange[0])),
      date1
    ]
    this.setState({
      customRange: newRange,
      customEditState: OFF
    })
    onSelect('CUSTOM', newRange)
  }
  render() {
    const { selected, availableTimeRange } = this.props
    const { customEditState, customRange, customRevertRange } = this.state
    const [date0, date1] = customRange

    return (
      <div className='DatePicker-container'>
        <Selector
          options={availableTimePeriods(this.props, this.state).map(periodIdWithLabel(this.props, this.state))}
          onSelect={this.handleSelected}
          selected={selected}
        />
        {
          customEditState === OFF
            ? null
            : <DatePicker
              selectedDate={
                customEditState === DATE0
                  ? date0 || new Date(Math.max(availableTimeRange[0], periods[selected](availableTimeRange[1])))
                  : date1 || availableTimeRange[1]}
              availableTimeRange={availableTimeRange}
              message={`Select the ${customEditState === DATE0 ? 'START' : 'END'} date...`}
              onSubmit={customEditState === DATE0 ? this.handleSubmitCustomDate0 : this.handleSubmitCustomDate1}
              onCancel={() => this.setState({ customEditState: OFF, customRange: customRevertRange })}
            />
        }
      </div>
    )
  }
}

export default PeriodSelector


// WEBPACK FOOTER //
// ./src/PDPeriodSelector.js